var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{attrs:{"type":"ios-headset","size":"24","color":"#7F92A9"}})}
var staticRenderFns = []

export { render, staticRenderFns }